/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Expected drop-off and pick-up on one ISO weekday. At least one time is set.
 */
export type children_ChildExpectedTimeEntryRequest = {
    arrival_time?: string;
    departure_time?: string;
    /**
     * Weekday is the ISO weekday, 1 = Monday ... 7 = Sunday.
     */
    weekday: children_ChildExpectedTimeEntryRequest.weekday;
};
export namespace children_ChildExpectedTimeEntryRequest {
    /**
     * Weekday is the ISO weekday, 1 = Monday ... 7 = Sunday.
     */
    export enum weekday {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6,
        '_7' = 7,
    }
}

